import { Vector3 } from "features/morphing/state/parameterAtoms";

export const isNonZeroVector = (
  vector: Vector3
) => {
  return vector.x * vector.y * vector.z !== 0;
};

export const isIntegerVector = (
  vector: Vector3
) => {
  return (
    Number.isInteger(vector.x) &&
    Number.isInteger(vector.y) &&
    Number.isInteger(vector.z)
  );
};

export const isNaturalVector = (
  vector: Vector3
) => {
  return (
    Number.isInteger(vector.x) && vector.x > 0 &&
    Number.isInteger(vector.y) && vector.y > 0 &&
    Number.isInteger(vector.z) && vector.z > 0
  );
};
